module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Black.e65d9d72.eot";